import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Amit Verma",
    company: "LogiTrack Solutions",
    quote:
      "S Infinite Express has redefined our delivery experience. The speed and tech support are unmatched!",
  },
  {
    name: "Priya Kapoor",
    company: "UrbanKart",
    quote:
      "Excellent customer service and real-time tracking make them a logistics partner we truly trust.",
  },
  {
    name: "John Fernandes",
    company: "IndoGlobal Exports",
    quote:
      "Their global shipping support has helped us grow our exports seamlessly. Highly recommended.",
  },
];

const Testimonials = () => (
  <section className="bg-gradient-to-br from-white via-gray-50 to-gray-100 py-24 px-6 lg:px-20 text-center">
    <motion.h2
      className="text-4xl font-extrabold text-gray-800 mb-16"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      What Our Clients Say
    </motion.h2>

    <div className="grid md:grid-cols-3 gap-10 max-w-7xl mx-auto">
      {testimonials.map((t, i) => (
        <motion.div
          key={i}
          className="bg-white/70 backdrop-blur-md rounded-3xl border border-gray-200 shadow-xl p-8 relative transition transform hover:-translate-y-1 hover:shadow-2xl"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.2, duration: 0.7 }}
        >
          {/* Decorative Quote Icon */}
          <div className="absolute -top-6 left-6 bg-indigo-600 p-2 rounded-full shadow text-white">
            <Quote className="w-5 h-5" />
          </div>

          <p className="text-gray-700 italic mb-6 leading-relaxed">“{t.quote}”</p>

          <div className="mt-6 border-t border-indigo-100 pt-4">
            <h4 className="text-lg font-semibold text-indigo-800">{t.name}</h4>
            <p className="text-sm text-indigo-600">{t.company}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);

export default Testimonials;
